module.exports = __webpack_public_path__ + "static/media/iconBj.1ab2ac4d.svg";